<template>
  <base-page
    :title="'Tax Rates'"
  >
    <template #actionButton>
      <tax-rate-create-dialog>
        <template v-slot:activator="{ on }">
          <v-btn
            rounded
            outlined
            color="primary"
            v-on="on"
          >
            <v-icon>add</v-icon> Add Tax Rate
          </v-btn>
        </template>
      </tax-rate-create-dialog>
    </template>

    <template #main>
      <tax-rate-table />
    </template>
  </base-page>
</template>
<script>
import BasePage from '@/views/BasePage.vue'
import TaxRateTable from '@/components/TaxRate/TaxRateTable.vue'
import TaxRateCreateDialog from "../../components/TaxRate/TaxRateCreateDialog"

export default {
  components: {
    TaxRateCreateDialog,
    TaxRateTable,
    BasePage,
  }
}
</script>
